import NetInfo from '../../adapters/netinfo';
import { OfflineAuthToken } from './types';
import { Platform } from 'react-native';

// Allow offline mode only on mobile apps, or when running Cypress tests
export const isOfflineModeAllowed =
  Boolean(window.Cypress) || Platform.OS !== 'web';

/**
 * Function to get the current network status immediately, without relying on
 * a React state change. This should be used when the component needs to know
 * if it's online or offline from the very first render.
 */
export const getOfflineModeActive = async () => {
  const networkStatus = await NetInfo.fetch();
  return (
    isOfflineModeAllowed &&
    !(networkStatus.isConnected && networkStatus.isInternetReachable)
  );
};

export const isOfflineAuthTokenValid = (authToken: OfflineAuthToken) =>
  authToken?.expires && new Date(authToken?.expires) > new Date();
